/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination (disabled: use {{pagination}} links) */
(function () {
    // Disabled to use server-rendered pagination controls
    // If you want infinite scroll back, call: pagination();
})();

/* Replace pagination text with post range (client-side) */
(function () {
    const container = document.querySelector('.pagination[data-page]');
    if (!container) {
        return;
    }

    const page = parseInt(container.getAttribute('data-page'), 10);
    const totalAttr = container.getAttribute('data-total');
    let total = totalAttr ? parseInt(totalAttr, 10) : NaN;
    const perPage = parseInt(container.getAttribute('data-per-page'), 10) || 10;
    const label = container.querySelector('.js-page-range');

    const pages = parseInt(container.getAttribute('data-pages'), 10);

    if ((!total || Number.isNaN(total)) && pages && perPage) {
        total = pages * perPage;
    }

    if (!label || !page || !total || Number.isNaN(total)) {
        return;
    }

    const start = (page - 1) * perPage + 1;
    const end = Math.min(page * perPage, total);

    label.textContent = `Posts ${start}–${end} of ${total}`;
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
